import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  fetchBookingList,
  fetchEventBookingList,
} from "../services/adminApiService/venueManagerApi/venueManagerApi";
import { PaginationControl } from "react-bootstrap-pagination-control";
import Form from "react-bootstrap/Form";
import PageTitle from "../jsx/layouts/PageTitle";
import useSearchValue from "../hooks/useSearchValue";

function BookingList() {
  const navigate = useNavigate();
  const loginDetails = JSON.parse(
    localStorage.getItem("login_Details") || "{}",
  );
  const [data, setData] = useState([]);
  const [venueFilter, setVenueFilter] = useState(
    loginDetails?.user?.venue_id || "",
  );
  const [dateFilter, setDateFiter] = useState("");
  const [sportFilter, setSportFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [sportOptions, setSportOptions] = useState([]);
  const [totalItems, setTotalItems] = useState("");
  // const [searchValue, setSearchValue] = useState("");
  const [searchText, setSearchText] = useState("");

  const [page, setPage] = useState(1);
  const {
    searchValue,
    setSearchValue,
    debouncedSearchValue,
    setDebouncedSearchValue,
  } = useSearchValue(1000);

  const limit = 10;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`; // "11 Oct, 2025"
  };
  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  useEffect(() => {
    // if (!venueFilter) return;
    const getBookings = async () => {
      const bookings = await fetchEventBookingList({
        page,
        limit,
        date: dateFilter,
        sport: sportFilter,
        status: statusFilter,
        search: searchValue,
      });

      setData(bookings.data || []);
      setTotalItems(bookings?.pagination?.total);

      // Extract unique sports from bookings
      const uniqueSportsMap = new Map();
      bookings?.data?.forEach((booking) => {
        const sportName = booking?.sport?.sport_name;
        const sportId = booking?.sport?.id;
        if (sportName && sportId && !uniqueSportsMap.has(sportId.toString())) {
          uniqueSportsMap.set(sportId.toString(), sportName);
        }
      });

      const uniqueSportOptions = Array.from(uniqueSportsMap).map(
        ([id, name]) => ({
          value: id,
          label: name,
        }),
      );

      setSportOptions(uniqueSportOptions);
    };

    getBookings();
  }, [
    page,
    dateFilter,
    sportFilter,
    statusFilter,
    debouncedSearchValue,
  ]);

  const handleBookingDetails = (id) => {
    localStorage.setItem("venueManagerBookingId", id);
    window.location.href = `/ticket-details/${id}`;
  };




  return (
    <>
      <h1 className="mb-3 fs-2 ">
        <PageTitle motherMenu={"Event Bookings"} activeMenu={"Booking List"} />
      </h1>
      <div className="d-flex justify-content-between align-items-end bg-default p-3 flex-wrap gap-3">
        {/* Search Input (Left Side - Wider) */}
        <Form.Group
          className="mb-0 flex-grow-1"
          controlId="exampleForm.ControlInput1"
        >
          <Form.Label>Search Events</Form.Label>
          <Form.Control
            type="text"
            placeholder="Search Events..."
            className="p-2"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </Form.Group>

        {/* Filters Group (Right Side - Fixed Size) */}
        <div className="d-flex gap-4 flex-grow-0">
          {/* <Form.Group className="mb-0" style={{ minWidth: "180px" }}>
            <Form.Label>Sport</Form.Label>
            <Form.Select
              value={sportFilter}
              onChange={(e) => setSportFilter(e.target.value)}
              className="p-2"
            >
              <option value="">All Sports</option>
              {sportOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group> */}
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFiter(e.target.value)}
              style={{ cursor: "pointer" }}
            />
          </Form.Group>

          <Form.Group style={{ minWidth: "180px" }}>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={statusFilter}
              onChange={handleStatusChange}
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                cursor: "pointer",
              }}
            >
              <option value="">Select status</option>
              {/* <option value="Inprocess">Inprocess</option> */}
              <option value="Canceled">Canceled</option>
              {/* <option value="Pending">Pending</option> */}
              <option value="Failed">Failed</option>
              <option value="Completed">Completed</option>
            </Form.Select>
          </Form.Group>
        </div>
      </div>

      <div className="table-wrapper">
        <div className="table-container">
          <table className="booking-table">
            <thead>
              <tr className="table-header-row">
                <th>
                  UserName, ID
                  <img
                    src="/logo/arrow-up-down.png"
                    width={8}
                    height={13}
                    alt="sort"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </th>
                <th>
                  Ticket ID
                  <img
                    src="/logo/arrow-up-down.png"
                    width={8}
                    height={13}
                    alt="sort"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </th>
                <th>Event</th>
                <th>Date</th>
                <th>Status</th>
                {/* <th>Approve/Reject</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((booking) => (
                <tr key={booking?.id} className="table-body-row">
                  <td>
                    <span className="booking-userid">{booking?.user_name}</span>{" "}
                    <br />
                    <span className="fs-6 booking-userid">
                      {booking?.user_email || "N/A"}
                    </span>
                  </td>
                  <td>
                    <div className="fs-5 booking-slot-time">
                      {booking?.booking_id}
                    </div>
                  </td>
                  <td>{booking?.event_name}</td>
                  <td>
                    <div className="booking-slot-date">
                      {formatDate(booking.start_date)} -{" "}
                      {formatDate(booking.end_date)}
                    </div>
                  </td>

                  <td className="td-middle">
                    <span
                      className={`status-badge ${
                        booking?.booking_status === "Pending"
                          ? "status-pending"
                          : booking?.booking_status === "Completed"
                            ? "status-completed"
                            : "status-canceled"
                      }`}
                    >
                      {booking?.booking_status}
                    </span>
                  </td>

                  {/* <td>
                {booking?.booking_status === "Pending" ? (
                  <div className="action-buttons">
                    <div onClick={() => handleCheck(booking?.id, "Completed")}>
                      <img src="/assets/check.png" alt="Check" width={20} height={20} />
                    </div>
                    <div onClick={() => handleRejectClick(booking?.id, "Canceled")}>
                      <img src="/assets/cancel.png" alt="Cancel" width={20} height={20} />
                    </div>
                  </div>
                ) : booking?.booking_status === "Completed" ? (
                  <div className="action-single">
                    <img src="/assets/check.png" alt="Check" width={20} height={20} />
                  </div>
                ) : booking?.booking_status === "Canceled" ? (
                  <div className="action-single">
                    <img src="/assets/cancel.png" alt="Cancel" width={20} height={20} />
                  </div>
                ) : null}
              </td> */}
                  <td>
                    <div
                      onClick={() => {
                        navigate(`/ticket-details/${booking?.booking_id}`);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        backgroundColor: "#eaecf0",
                        padding: "6px 10px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        width: "fit-content",
                        margin: "0 auto",
                      }}
                    >
                      <FaEye
                        style={{
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      <span>View</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {data?.length > 0 ? (
        <PaginationControl
          page={page}
          between={4}
          total={totalItems || 250}
          limit={limit}
          changePage={(page) => {
            setPage(page);
          }}
          ellipsis={1}
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center fs-4 p-3">
          No data available
        </div>
      )}

      {/* {openConfirmModal && (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Confirm Booking</h2>
        <p>Are you sure you want to confirm this booking?</p>
        <div className="modal-actions">
          <button className="btn-outline" onClick={() => setOpenConfirmModal(false)}>Cancel</button>
          <button className="btn-primary" onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  )} */}
    </>
  );
}

export default BookingList;
